import React from 'react';

export default function SheepEarsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="38.0,17.86 27.89,22.05 25.63,16.61 35.74,12.42" fill="#EFDEAC" />
      <polygon points="38.0,17.86 27.89,22.05 25.63,16.61 35.74,12.42" fill="#EFDEAC" />
      <polygon points="12.11,22.05 2.0,17.86 4.26,12.42 14.37,16.61" fill="#EFDEAC" />
      <polygon points="12.11,22.05 2.0,17.86 4.26,12.42 14.37,16.61" fill="#EFDEAC" />
      <polygon points="37.08,16.88 28.53,20.43 27.24,17.32 35.79,13.77" fill="#EFDEAC" />
      <polygon points="28.53,20.43 37.08,16.88 36.58,16.63 28.02,20.17" fill="#DEBC56" opacity="0.95" />
      <polygon points="28.53,20.43 28.02,20.17 26.73,17.06 27.24,17.32" fill="#DEBC56" opacity="0.95" />
      <polygon points="12.48,20.43 3.93,16.88 5.22,13.77 13.77,17.32" fill="#EFDEAC" />
      <polygon points="3.93,16.88 3.42,16.63 4.71,13.52 5.22,13.77" fill="#DEBC56" opacity="0.95" />
      <polygon points="30.31,24.11 28.63,24.11 28.63,21.59 30.31,21.59" fill="#EFDEAC" />
      <polygon points="28.63,24.11 28.12,23.86 28.12,21.34 28.63,21.59" fill="#DEBC56" opacity="0.95" />
      <polygon points="12.63,24.11 10.95,24.11 10.95,21.59 12.63,21.59" fill="#EFDEAC" />
      <polygon points="10.95,24.11 10.45,23.86 10.45,21.34 10.95,21.59" fill="#DEBC56" opacity="0.95" />
      <polygon points="31.97,24.87 28.61,24.87 27.89,22.13 31.26,22.13" fill="#EFDEAC" />
      <polygon points="28.61,24.87 31.97,24.87 31.26,26.9 27.89,26.9" fill="#DEBC56" opacity="0.95" />
      <polygon points="28.61,24.87 27.89,26.9 27.18,24.16 27.89,22.13" fill="#DEBC56" opacity="0.95" />
      <polygon points="14.29,24.87 10.93,24.87 10.21,22.13 13.58,22.13" fill="#EFDEAC" />
      <polygon points="10.93,24.87 14.29,24.87 13.58,26.9 10.21,26.9" fill="#DEBC56" opacity="0.95" />
      <polygon points="10.93,24.87 10.21,26.9 9.5,24.16 10.21,22.13" fill="#DEBC56" opacity="0.95" />
      <polygon points="30.62,26.32 29.78,26.32 29.6,25.63 30.44,25.63" fill="#EFDEAC" />
      <polygon points="12.94,26.32 12.1,26.32 11.92,25.63 12.76,25.63" fill="#EFDEAC" />
      <polygon points="32.15,25.56 28.78,25.56 28.61,24.87 31.97,24.87" fill="#EFDEAC" />
      <polygon points="28.78,25.56 32.15,25.56 31.44,27.58 28.07,27.58" fill="#DEBC56" opacity="0.95" />
      <polygon points="28.78,25.56 28.07,27.58 27.89,26.9 28.61,24.87" fill="#DEBC56" opacity="0.95" />
      <polygon points="32.15,25.56 28.78,25.56 28.61,24.87 31.97,24.87" fill="#EFDEAC" />
      <polygon points="28.78,25.56 32.15,25.56 31.44,27.58 28.07,27.58" fill="#DEBC56" opacity="0.95" />
      <polygon points="28.78,25.56 28.07,27.58 27.89,26.9 28.61,24.87" fill="#DEBC56" opacity="0.95" />
      <polygon points="14.47,25.56 11.11,25.56 10.93,24.87 14.29,24.87" fill="#EFDEAC" />
      <polygon points="11.11,25.56 14.47,25.56 13.76,27.58 10.39,27.58" fill="#DEBC56" opacity="0.95" />
      <polygon points="11.11,25.56 10.39,27.58 10.21,26.9 10.93,24.87" fill="#DEBC56" opacity="0.95" />
      <polygon points="14.47,25.56 11.11,25.56 10.93,24.87 14.29,24.87" fill="#EFDEAC" />
      <polygon points="11.11,25.56 14.47,25.56 13.76,27.58 10.39,27.58" fill="#DEBC56" opacity="0.95" />
      <polygon points="11.11,25.56 10.39,27.58 10.21,26.9 10.93,24.87" fill="#DEBC56" opacity="0.95" />
    </svg>
  );
}
